import { Component, Input, OnInit } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { TabStateService } from './tab-state.service';

@Component({
  selector: 'fin-tab',
  templateUrl: 'tab.component.html',
})
export class TabComponent implements OnInit {
  @Input()
  tabId: string;

  selected$: Observable<boolean>;

  constructor(private service: TabStateService) {}

  ngOnInit(): void {
    this.selected$ = this.service.getSelectedTabId().pipe(map((id) => id === this.tabId));
  }
}
